export const CLEAR_USER_PAYMENT_INFOS = 'CLEAR_USER_PAYMENT_INFOS';

export const clearUserPaymentInfos = () => ({
  type: CLEAR_USER_PAYMENT_INFOS
});
